module.exports = __webpack_public_path__ + "img/hr-tree-04-e-leaves.2d6030a5.png";